<div class="content title-screen">
  <span class="logo" [ngClass]="{'wellcome': loading}">
    KEEP <br /> OUT!
  </span>
  <div class="message-panel" (click)="next()">
    <div class="message-panel-background"></div>
    <div class="border-line">
    </div>
    <div class="message-panel-content" [ngSwitch]="index">
      <div class="character-wrapper" *ngIf="index>0">
        <div class="character character1" [@inOutAnimation] *ngIf="index==1"></div>
        <div class="character character2" [@inOutAnimation] *ngIf="index==2"></div>
        <div class="character character3" [@inOutAnimation] *ngIf="index==3"></div>
      </div>
      <div class="message" [ngSwitch]="index">
        <ng-template [ngSwitchDefault]>
          <div class="no-sub" [@inOutAnimation]>
            <span>How long can you keep them out?</span></div>
        </ng-template>
        <ng-template [ngSwitchCase]="'1'">

          <div class="text subtitulo" [@inOutAnimation]>
            <span>OBJETIVO</span>
          </div>
          <div class="text introduccion" [@inOutAnimation]>
            <span>acá va una explicación del juego que tiene un poco mas de sentido </span>
          </div>

        </ng-template>
        <ng-template [ngSwitchCase]="'2'">

          <div class="text subtitulo" [@inOutAnimation]>
            <span>OBJETIVO</span>
          </div>
          <div class="text introduccion" [@inOutAnimation]>
            <span>Otra Explicación </span>
          </div>

        </ng-template>
        <ng-template [ngSwitchCase]="'3'">

          <div class="text subtitulo" [@inOutAnimation]>
            <span>OBJETIVO</span>
          </div>
          <div class="text introduccion" [@inOutAnimation]>
            <span>Una Explicación más </span>
          </div>

        </ng-template>
      </div>







    </div>
    <div class="stepper">
      <i class="fa fa-circle" [ngClass]="{'selected': index==1}"></i>
      <i class="fa fa-circle " [ngClass]="{'selected': index==2}"></i>
      <i class="fa fa-circle " [ngClass]="{'selected': index==3}"></i>
    </div>

  </div>
  <div class="loading" *ngIf="loading" [@outAnimation]>
    <loading-bar [progress]="progress | async">
    </loading-bar>
  </div>
